import { APIFactory } from '../api/api.factory'
const MiscCostApi = APIFactory.get('miscCost')

export default {
    async getMiscCost(erID) {
        const { data } = await MiscCostApi.getMiscCost(erID)
        return data;
    },
    async getMiscCostTypes() {
        const { data } = await MiscCostApi.getMiscCostTypes()
        return data;
    }
}